<template>
  <div class="container content-padding box-bg">
    <div class="container-main">
      <div class="container-main-header">
        <div class="search-box" style="padding-bottom: 0px">
          <div class="index-top-box">
            <font class="index-search-font" style="font-size: 16px">智能控制</font>
            <span class="index-top-title" style="font-size: 16px">/添加执行动作</span>
          </div>
          <div style="height: 16px"></div>
          <div class="top-opption" style="bottom: 19px">
            <el-button type="primary" class="left" @click="handleAdd()" v-if="tableData.length > 0">+添加执行动作</el-button>
            <el-button type="primary" class="step-positon" @click="goTo2()">上一步</el-button>
            <el-button style="background-color: rgb(228, 240, 253); !important" disabled class="step-positon"
              @click="goTo2()">下一步</el-button>
          </div>
        </div>
      </div>

      <div class="equipmentlist box-padding-mide">
        <div class="mudel-left-box">
          <div class="container-content-head">
            <span class="title">添加执行动作</span>
          </div>
          <div class="container-content tablecontent">
            <div class="equipmentcenter">
              <el-steps :active="2" align-center>
                <el-step title="添加控制"></el-step>
                <el-step title="添加触发条件"></el-step>
                <el-step title="添加执行动作"></el-step>
              </el-steps>
            </div>
            <div class="equipmentcenter-step-box"></div>
            <div class="equipmentcenter-opption-box inside-box" v-if="tableData.length <= 0"
              style="width: 700px; border: none !important">
              <el-form ref="form" :model="form" label-width="100px">
                <el-form-item label="动作设备：" class="newbox2">
                  <el-select v-model="form.eid" placeholder="请选择动作设备" @change="deviceChange"
                    style="width: 435px !important" clearable>
                    <el-option v-for="(item, index) in deviceArray" :key="index" :label="item.name"
                      :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
                <ul style="position: relative" v-for="(item2, index2) in form.actionList" :key="index2">
                  <el-form-item label="动作属性：" class="newbox2">
                    <el-select v-model="item2.attributeId" placeholder="请选择动作属性" style="width: 435px !important" clearable
                      @change="attributeChange(index2)">
                      <el-option v-for="(item3, index3) in attributeArray" :key="index3" :label="item3.name"
                        :value="item3.id"></el-option>
                    </el-select>
                    <a class="sc-btn31" @click="delAttribute(index2)">删除</a>
                  </el-form-item>
                  <el-form-item label="动作状态：" v-if="item2.switchType == 0 ||
                    item2.switchType == 3 ||
                    item2.switchType == 5 ||
                    item2.switchType == 6 ||
                    item2.switchType == 7 ||
                    item2.switchType == 8
                    " class="newbox2">
                    <el-select v-if="item2.switchType == 0 || item2.switchType == 3" v-model="item2.executionValue"
                      placeholder="请选择动作状态" style="width: 435px !important" clearable>
                      <el-option label="关闭" value="0"></el-option>
                      <el-option label="开启" value="1"></el-option>
                    </el-select>

                    <el-select v-if="item2.switchType == 5" v-model="item2.executionValue" placeholder="请选择动作状态"
                      style="width: 435px !important" clearable>
                      <el-option label="停止" value="0"></el-option>
                      <el-option label="正开" value="1"></el-option>
                      <el-option label="反开" value="2"></el-option>
                    </el-select>
                    <el-select v-if="item2.switchType == 6" v-model="item2.executionValue" placeholder="请选择动作状态"
                      style="width: 435px !important" clearable>
                      <el-option label="展开停止" value="0"></el-option>
                      <el-option label="收缩停止" value="1"></el-option>
                      <el-option label="展开" value="2"></el-option>
                      <el-option label="收缩" value="3"></el-option>
                    </el-select>
                    <el-select v-if="item2.switchType == 7" v-model="item2.executionValue" placeholder="请选择动作状态"
                      style="width: 435px !important" clearable>
                      <el-option label="下发" value="0"></el-option>
                    </el-select>
                    <el-select v-if="item2.switchType == 8" v-model="item2.executionValue" placeholder="请选择动作状态"
                      style="width: 435px !important" clearable>
                      <el-option v-for="(item4, index4) in item2.customSwitchCmds" :key="index4" :label="item4.name"
                        :value="item4.id + ''"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="动作执行值：" v-if="item2.switchType == 1 || item2.switchType == 4" class="newbox2">
                    <el-input-number placeholder="请输入动作执行值" v-model="item2.executionValue" :min="0" :max="100" :step="1"
                      size="small" clearable></el-input-number>
                  </el-form-item>
                  <el-form-item label="发送类型：" class="newbox2">
                    <el-select v-model="item2.sendType" placeholder="请选择发送类型" style="width: 435px !important" clearable>
                      <el-option v-for="item5 in sendTypeArray" :key="item5.value" :label="item5.name"
                        :value="item5.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="发送间隔：" class="newbox2" v-if="item2.sendType == 3">
                    <el-input-number placeholder="请输入发送间隔（秒）" v-model="item2.intervalTime" :min="0" :max="99999999"
                      :step="1" size="small" clearable></el-input-number>
                  </el-form-item>
                  <el-form-item label="二次状态：" class="newbox2" v-if="item2.sendType == 3 &&
                    (item2.switchType == 0 ||
                      item2.switchType == 3 ||
                      item2.switchType == 5 ||
                      item2.switchType == 6 ||
                      item2.switchType == 7 ||
                      item2.switchType == 8)
                    ">
                    <el-select v-if="item2.switchType == 0 || item2.switchType == 3" v-model="item2.executionValueTwo"
                      placeholder="请选择二次状态" style="width: 435px !important" clearable>
                      <el-option label="关闭" value="0"></el-option>
                      <el-option label="开启" value="1"></el-option>
                    </el-select>

                    <el-select v-if="item2.switchType == 5" v-model="item2.executionValueTwo" placeholder="请选择二次状态"
                      style="width: 435px !important" clearable>
                      <el-option label="停止" value="0"></el-option>
                      <el-option label="正开" value="1"></el-option>
                      <el-option label="反开" value="2"></el-option>
                    </el-select>
                    <el-select v-if="item2.switchType == 6" v-model="item2.executionValueTwo" placeholder="请选择二次状态"
                      style="width: 435px !important" clearable>
                      <el-option label="展开停止" value="0"></el-option>
                      <el-option label="收缩停止" value="1"></el-option>
                      <el-option label="展开" value="2"></el-option>
                      <el-option label="收缩" value="3"></el-option>
                    </el-select>
                    <el-select v-if="item2.switchType == 7" v-model="item2.executionValueTwo" placeholder="请选择二次状态"
                      style="width: 435px !important" clearable>
                      <el-option label="下发" value="0"></el-option>
                    </el-select>
                    <el-select v-if="item2.switchType == 8" v-model="item2.executionValueTwo" placeholder="请选择二次状态"
                      style="width: 435px !important" clearable>
                      <el-option v-for="(item4, index4) in item2.customSwitchCmds" :key="index4" :label="item4.name"
                        :value="item4.id + ''"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="二次执行值：" class="newbox2" v-if="item2.sendType == 3 &&
                    (item2.switchType == 1 || item2.switchType == 4)
                    ">
                    <el-input-number placeholder="请输入二次执行值" v-model="item2.executionValueTwo" :min="0" :max="100"
                      :step="1" size="small" clearable></el-input-number>
                  </el-form-item>
                  <el-form-item label="发送间隙：" v-if="item2.sendType == 5" class="newbox2">
                    <el-input-number placeholder="请输入发送间隙（秒）" v-model="item2.needIntervalTime" :min="0" :max="99999999"
                      :step="1" size="small" clearable></el-input-number>
                  </el-form-item>
                  <el-form-item label="触发次数：" v-if="item2.sendType == 5" class="newbox2">
                    <el-input-number placeholder="请输入触发次数" v-model="item2.needTriggerNum" :min="0" :max="99999999"
                      :step="1" size="small" clearable></el-input-number>
                  </el-form-item>
                  <el-form-item label="下发权重：" class="newbox2">
                    <el-input-number placeholder="请输入下发权重" v-model="item2.weight" :min="1" :max="100" :step="1"
                      size="small" clearable></el-input-number>
                  </el-form-item>
                  <el-form-item label="触发条件：" class="newbox2">
                    <el-select v-model="item2.linkids" placeholder="请选择触发条件" multiple collapse-tags
                      style="width: 435px !important" clearable>
                      <el-option v-for="(item6, index6) in controlArray" :key="index6" :label="item6.name"
                        :value="item6.value"></el-option>
                    </el-select>
                  </el-form-item>
                </ul>
                <el-form-item>
                  <a class="td-opption" @click="addAttribute()">+添加动作属性</a>
                </el-form-item>
                <el-form-item style="text-align: center; margin-top: 20px">
                  <el-button type="primary" style="width: 120px" @click="handleSave()">保存</el-button>
                </el-form-item>
              </el-form>
            </div>
            <div class="container-content tablecontent" v-if="tableData.length > 0">
              <el-table class="data-table" style="width: 100%" :data="tableData" align="center"
                :header-cell-style="{ background: '#F6F6F6' }" v-loading="isloading">
                <el-table-column label="设备名称" width="150px">
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" :content="scope.row.deviceName" placement="right-start">
                      <p>{{ scope.row.deviceName }}</p>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column label="属性名称" width="150px">
                  <template slot-scope="scope">
                    <p>{{ scope.row.attributeName }}</p>
                  </template>
                </el-table-column>
                <el-table-column label="执行动作" width="150px">
                  <template slot-scope="scope">
                    <p>{{ scope.row.action }}</p>
                  </template>
                </el-table-column>
                <el-table-column label="发送类型" width="150px">
                  <template slot-scope="scope">
                    <!--（0下发一次，1一直下发，2检测开关状态下发） SendType-->
                    <p>{{ scope.row.sendType | SendType }}</p>
                  </template>
                </el-table-column>
                <el-table-column label="触发条件">
                  <template slot-scope="scope">
                    <p>{{ scope.row.triggerCondition }}</p>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="150px">
                  <template slot-scope="scope">
                    <a class="td-opption" @click="handleUpdate(scope.row.id, scope.row.switchType)">编辑</a>
                    <a class="td-opption del" @click="handleDel(scope.row.id)">删除</a>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <el-dialog :title="title" :visible.sync="dialogVisible" width="740px" :before-close="handleClose">
              <div class="equipmentcenter-opption-box" style="padding-right: 61px !important">
                <el-form ref="form" :model="form" label-width="100px">
                  <el-form-item label="动作设备：" class="newbox2">
                    <el-select v-model="form.eid" placeholder="请选择动作设备" @change="deviceChange"
                      style="width: 435px !important" clearable>
                      <el-option v-for="(item, index) in deviceArray" :key="index" :label="item.name"
                        :value="item.value"></el-option>
                    </el-select>
                  </el-form-item>
                  <ul style="position: relative" v-for="(item2, index2) in form.actionList" :key="index2">
                    <el-form-item label="动作属性：" class="newbox2">
                      <el-select v-model="item2.attributeId" placeholder="请选择动作属性" style="width: 435px !important"
                        clearable @change="attributeChange(index2)">
                        <el-option v-for="(item3, index3) in attributeArray" :key="index3" :label="item3.name"
                          :value="item3.id"></el-option>
                      </el-select>
                      <a class="sc-btn31" @click="delAttribute(index2)">删除</a>
                    </el-form-item>
                    <el-form-item label="动作状态：" v-if="item2.switchType == 0 ||
                      item2.switchType == 3 ||
                      item2.switchType == 5 ||
                      item2.switchType == 6 ||
                      item2.switchType == 7 ||
                      item2.switchType == 8
                      " class="newbox2">
                      <el-select v-if="item2.switchType == 0 || item2.switchType == 3" v-model="item2.executionValue"
                        placeholder="请选择动作状态" style="width: 435px !important" clearable>
                        <el-option label="关闭" value="0"></el-option>
                        <el-option label="开启" value="1"></el-option>
                      </el-select>

                      <el-select v-if="item2.switchType == 5" v-model="item2.executionValue" placeholder="请选择动作状态"
                        style="width: 435px !important" clearable>
                        <el-option label="停止" value="0"></el-option>
                        <el-option label="正开" value="1"></el-option>
                        <el-option label="反开" value="2"></el-option>
                      </el-select>
                      <el-select v-if="item2.switchType == 6" v-model="item2.executionValue" placeholder="请选择动作状态"
                        style="width: 435px !important" clearable>
                        <el-option label="展开停止" value="0"></el-option>
                        <el-option label="收缩停止" value="1"></el-option>
                        <el-option label="展开" value="2"></el-option>
                        <el-option label="收缩" value="3"></el-option>
                      </el-select>
                      <el-select v-if="item2.switchType == 7" v-model="item2.executionValue" placeholder="请选择动作状态"
                        style="width: 435px !important" clearable>
                        <el-option label="下发" value="0"></el-option>
                      </el-select>
                      <el-select v-if="item2.switchType == 8" v-model="item2.executionValue" placeholder="请选择动作状态"
                        style="width: 435px !important" clearable>
                        <el-option v-for="(item4, index4) in item2.customSwitchCmds" :key="index4" :label="item4.name"
                          :value="item4.id + ''"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="动作执行值：" v-if="item2.switchType == 1 || item2.switchType == 4" class="newbox2">
                      <el-input-number placeholder="请输入动作执行值" v-model="item2.executionValue" :min="0" :max="100" :step="1"
                        size="small" clearable></el-input-number>
                    </el-form-item>
                    <el-form-item label="发送类型：" class="newbox2">
                      <el-select v-model="item2.sendType" placeholder="请选择发送类型" style="width: 435px !important" clearable>
                        <el-option v-for="item5 in sendTypeArray" :key="item5.value" :label="item5.name"
                          :value="item5.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="发送间隔：" class="newbox2" v-if="item2.sendType == 3">
                      <el-input-number placeholder="请输入发送间隔（秒）" v-model="item2.intervalTime" :min="0" :max="99999999"
                        :step="1" size="small" clearable></el-input-number>
                    </el-form-item>
                    <el-form-item label="二次状态：" class="newbox2" v-if="item2.sendType == 3 &&
                      (item2.switchType == 0 ||
                        item2.switchType == 3 ||
                        item2.switchType == 5 ||
                        item2.switchType == 6 ||
                        item2.switchType == 7 ||
                        item2.switchType == 8)
                      ">
                      <el-select v-if="item2.switchType == 0 || item2.switchType == 3" v-model="item2.executionValueTwo"
                        placeholder="请选择二次状态" style="width: 435px !important" clearable>
                        <el-option label="关闭" value="0"></el-option>
                        <el-option label="开启" value="1"></el-option>
                      </el-select>

                      <el-select v-if="item2.switchType == 5" v-model="item2.executionValueTwo" placeholder="请选择二次状态"
                        style="width: 435px !important" clearable>
                        <el-option label="停止" value="0"></el-option>
                        <el-option label="正开" value="1"></el-option>
                        <el-option label="反开" value="2"></el-option>
                      </el-select>
                      <el-select v-if="item2.switchType == 6" v-model="item2.executionValueTwo" placeholder="请选择二次状态"
                        style="width: 435px !important" clearable>
                        <el-option label="展开停止" value="0"></el-option>
                        <el-option label="收缩停止" value="1"></el-option>
                        <el-option label="展开" value="2"></el-option>
                        <el-option label="收缩" value="3"></el-option>
                      </el-select>
                      <el-select v-if="item2.switchType == 7" v-model="item2.executionValueTwo" placeholder="请选择二次状态"
                        style="width: 435px !important" clearable>
                        <el-option label="下发" value="0"></el-option>
                      </el-select>
                      <el-select v-if="item2.switchType == 8" v-model="item2.executionValueTwo" placeholder="请选择二次状态"
                        style="width: 435px !important" clearable>
                        <el-option v-for="(item4, index4) in item2.customSwitchCmds" :key="index4" :label="item4.name"
                          :value="item4.id + ''"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="二次执行值：" class="newbox2" v-if="item2.sendType == 3 &&
                      (item2.switchType == 1 || item2.switchType == 4)
                      ">
                      <el-input-number placeholder="请输入二次执行值" v-model="item2.executionValueTwo" :min="0" :max="100"
                        :step="1" size="small" clearable></el-input-number>
                    </el-form-item>
                    <el-form-item label="发送间隙：" v-if="item2.sendType == 5" class="newbox2">
                      <el-input-number placeholder="请输入发送间隙（秒）" v-model="item2.needIntervalTime" :min="0" :max="99999999"
                        :step="1" size="small" clearable></el-input-number>
                    </el-form-item>
                    <el-form-item label="触发次数：" v-if="item2.sendType == 5" class="newbox2">
                      <el-input-number placeholder="请输入触发次数" v-model="item2.needTriggerNum" :min="0" :max="99999999"
                        :step="1" size="small" clearable></el-input-number>
                    </el-form-item>
                    <el-form-item label="下发权重：" class="newbox2">
                      <el-input-number placeholder="请输入下发权重" v-model="item2.weight" :min="1" :max="100" :step="1"
                        size="small" clearable></el-input-number>
                    </el-form-item>
                    <el-form-item label="触发条件：" class="newbox2">
                      <el-select v-model="item2.linkids" placeholder="请选择触发条件" multiple collapse-tags
                        style="width: 435px !important" clearable>
                        <el-option v-for="(item6, index6) in controlArray" :key="index6" :label="item6.name"
                          :value="item6.value"></el-option>
                      </el-select>
                    </el-form-item>
                  </ul>
                  <el-form-item>
                    <a class="td-opption" @click="addAttribute()">+添加动作属性</a>
                  </el-form-item>
                  <el-form-item style="text-align: center; margin-top: 20px">
                    <el-button type="info" style="width: 120px" @click="handleClose()">取消</el-button>
                    <el-button type="primary" style="width: 120px" @click="handleSave()">保存</el-button>
                  </el-form-item>
                </el-form>
              </div>
            </el-dialog>
          </div>
        </div>
        <div class="mudel-right-box">
          <div class="mudel-right-box-box" style="height: 496px">
            <div class="container-content-head" style="border-bottom: 1px solid #f4f8f9">
              <i class="top-nav"></i>
              <span class="title">词条注释</span>
            </div>
            <div class="mudel-expalin">
              <p>动作属性: 该设备下需要触发的属性。</p>
              <p>动作状态: 基础开关只有2类状态值（开启、关闭）。</p>
              <p>动作属性值: 模式开关（类似阀门开关）所代表开启式的张合度。</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "equipmentcenter",
  components: {},
  data() {
    return {
      tableData: [],
      form: {
        linkageControlId: "",
        actionList: [
          {
            controlType: 0,
            linkageControlId: "",
            type: 3,
            eid: "",
            attributeId: "",
            executionValue: "",
            executionValueTwo: "",
            sendType: "",
            needTriggerNum: "",
            needIntervalTime: "",
            weight: "",
            linkids: [],
          },
        ],
      },
      dialogVisible: false,
      title: "添加执行动作",
      sendTypeArray: [
        // 发送类型数组
        {
          value: 0,
          name: "下发一次",
        },
        {
          value: 1,
          name: "一直下发",
        },
        {
          value: 2,
          name: "检测开关状态下发",
        },
        {
          value: 3,
          name: "下发二次",
        },
        {
          value: 5,
          name: "检测触发次数下发",
        },
      ],
      deviceArray: [], // 设备数组
      attributeArray: [], // 属性数组
      controlArray: [], // 条件数组
      linkageControlId: "", // 联动控制id
      controlType: "", // 控制类型
    };
  },
  computed: {
    ...mapState("user", ["token"]),
  },
  mounted() {
    this.linkageControlId = sessionStorage.getItem("projectEditId");
    this.controlType = sessionStorage.getItem("kztype");

    // 获取列表
    this.getList();

    // 获取开关设备列表
    this.getSwitchList();

    if (this.controlType == "1") {
      // 获取自动条件列表
      this.getConditionList();
    } else {
      // 获取定时条件列表
      this.getTimeList();
    }
  },
  methods: {
    // 上一步
    goTo2() {
      if (this.controlType == 1) {
        //自动
        this.$router.push({
          name: `Linkagecenter4`,
        });
      } else if (this.controlType == 0) {
        //定时
        this.$router.push({
          name: `Linkagecenter2`,
        });
      }
    },
    // 获取自动条件列表
    getConditionList() {
      this.$api.device
        .getConditionListByControlId(this.linkageControlId)
        .then((res) => {
          if (res.code == 200) {
            this.controlArray = [];
            for (var i = 0; i < res.data.length; i++) {
              var obj = {};
              obj.value = res.data[i].id;

              if (
                res.data[i].switchType == 0 ||
                res.data[i].switchType == 3 ||
                res.data[i].switchType == 2
              ) {
                // 基础开关、只读开关
                if (res.data[i].startValue == 0) {
                  res.data[i].condition = "关闭";
                } else if (res.data[i].startValue == 1) {
                  res.data[i].condition = "开启";
                }
              } else if (res.data[i].switchType == 5) {
                // 正反转开关
                if (res.data[i].startValue == 0) {
                  res.data[i].condition = "停止";
                } else if (res.data[i].startValue == 1) {
                  res.data[i].condition = "正开";
                } else if (res.data[i].startValue == 2) {
                  res.data[i].condition = "反开";
                }
              } else if (res.data[i].switchType == 6) {
                // 展开收缩开关
                if (res.data[i].startValue == 0) {
                  res.data[i].condition = "展开停止";
                } else if (res.data[i].startValue == 1) {
                  res.data[i].condition = "收缩停止";
                } else if (res.data[i].startValue == 2) {
                  res.data[i].condition = "展开";
                } else if (res.data[i].startValue == 3) {
                  res.data[i].condition = "收缩";
                }
              } else if (res.data[i].switchType == 7) {
                // 下发开关
                res.data[i].condition = "下发";
              } else if (res.data[i].switchType == 8) {
                // 自定义开关
                res.data[i].condition = res.data[i].switchCmdName;
              } else {
                // 数值设备、模拟开关
                if (res.data[i].endValue == undefined) {
                  res.data[i].condition = "≥" + res.data[i].startValue;
                } else if (res.data[i].startValue == undefined) {
                  res.data[i].condition = "≤" + res.data[i].endValue;
                } else {
                  res.data[i].condition =
                    "≥" + res.data[i].startValue + "且≤" + res.data[i].endValue;
                }
              }

              obj.name =
                res.data[i].deviceName +
                "_" +
                res.data[i].attributeName +
                "_" +
                res.data[i].condition;

              this.controlArray.push(obj);
            }
          }
        });
    },
    // 获取定时条件列表
    getTimeList() {
      this.$api.device
        .getTimeListByControlId(this.linkageControlId)
        .then((res) => {
          if (res.code == 200) {
            this.controlArray = [];
            for (var i = 0; i < res.data.length; i++) {
              var obj = {};
              obj.value = res.data[i].id;

              if (res.data[i].timeType == "0") {
                var arr = res.data[i].executionWeek.split(",");
                for (var j = 0; j < arr.length; j++) {
                  if (arr[j] == "1") {
                    arr[j] = "一";
                  } else if (arr[j] == "2") {
                    arr[j] = "二";
                  } else if (arr[j] == "3") {
                    arr[j] = "三";
                  } else if (arr[j] == "4") {
                    arr[j] = "四";
                  } else if (arr[j] == "5") {
                    arr[j] = "五";
                  } else if (arr[j] == "6") {
                    arr[j] = "六";
                  } else if (arr[j] == "7") {
                    arr[j] = "日";
                  }
                }
                res.data[i].executionWeek2 = "每周" + arr.join("、");
              } else {
                res.data[i].executionWeek2 = this.$utils.zhDate(
                  res.data[i].executionDate
                );
              }
              obj.name =
                res.data[i].startTime +
                "_" +
                res.data[i].endTime +
                "_" +
                res.data[i].executionWeek2;

              this.controlArray.push(obj);
            }
          }
        });
    },
    // 保存
    handleSave() {
      if (this.form.eid == "" || this.form.eid == undefined) {
        this.$toaster.error("请选择动作设备");
        return;
      }

      for (var i = 0; i < this.form.actionList.length; i++) {
        this.form.actionList[i].eid = this.form.eid;

        if (
          this.form.actionList[i].attributeId == "" ||
          this.form.actionList[i].attributeId == undefined
        ) {
          this.$toaster.error("请选择动作属性");
          return;
        }

        if (
          this.form.actionList[i].executionValue === "" ||
          this.form.actionList[i].executionValue == undefined
        ) {
          if (this.item2.switchType == 1 || this.item2.switchType == 4) {
            this.$toaster.error("请输入动作执行值");
          } else {
            this.$toaster.error("请选择动作状态");
          }
          return;
        }

        if (
          this.form.actionList[i].sendType === "" ||
          this.form.actionList[i].sendType == undefined
        ) {
          this.$toaster.error("请选择发送类型");
          return;
        }

        if (
          this.form.actionList[i].sendType == "3" &&
          (this.form.actionList[i].intervalTime === "" ||
            this.form.actionList[i].intervalTime == undefined)
        ) {
          this.$toaster.error("请输入发送间隔");
          return;
        }

        if (
          this.form.actionList[i].sendType == "3" &&
          (this.form.actionList[i].executionValueTwo === "" ||
            this.form.actionList[i].executionValueTwo == undefined)
        ) {
          if (this.item2.switchType == 1 || this.item2.switchType == 4) {
            this.$toaster.error("请输入二次执行值");
          } else {
            this.$toaster.error("请选择二次状态");
          }
          return;
        }

        if (
          this.form.actionList[i].sendType == "5" &&
          (this.form.actionList[i].needIntervalTime === "" ||
            this.form.actionList[i].needIntervalTime == undefined)
        ) {
          this.$toaster.error("请输入发送间隙");
          return;
        }

        if (
          this.form.actionList[i].sendType == "5" &&
          (this.form.actionList[i].needTriggerNum === "" ||
            this.form.actionList[i].needTriggerNum == undefined)
        ) {
          this.$toaster.error("请输入触发次数");
          return;
        }

        if (
          this.form.actionList[i].weight === "" ||
          this.form.actionList[i].weight == undefined
        ) {
          this.$toaster.error("请输入下发权重");
          return;
        }

        if (
          this.form.actionList[i].linkids == "" ||
          this.form.actionList[i].linkids == undefined
        ) {
          this.$toaster.error("请选择触发条件");
          return;
        }

        this.form.actionList[i].eid = this.form.eid;
        this.form.actionList[i].type = 3;
        this.form.actionList[i].controlType = this.controlType;
        if (this.controlType == "1") {
          //自动
          this.form.actionList[i].linkageControlConditionId =
            this.form.actionList[i].linkids.join(",");
          this.form.actionList[i].linkageControlTimeId = undefined;
        } else {
          this.form.actionList[i].linkageControlConditionId = undefined;
          this.form.actionList[i].linkageControlTimeId =
            this.form.actionList[i].linkids.join(",");
        }
      }

      this.form.token = this.token;
      this.form.linkageControlId = this.linkageControlId;

      this.$api.device.saveLinkageControlAction(this.form).then((res) => {
        if (res.code == 200) {
          this.$toaster.ok("成功", res.msg);
          this.getList();
          this.handleClose();
        }
      });
    },
    // 添加属性
    addAttribute: function () {
      let cope = {
        controlType: this.controlType,
        linkageControlId: this.linkageControlId,
        type: 3,
        eid: this.form.eid,
        attributeId: "",
        executionValue: "",
        executionValueTwo: "",
        sendType: "",
        needTriggerNum: "",
        needIntervalTime: "",
        weight: "",
        linkids: [],
        switchType: 0,
        customSwitchCmds: [],
      };
      this.form.actionList.push(cope);
    },
    // 删除属性
    delAttribute: function (index) {
      this.form.actionList.splice(index, 1);
    },
    // 获取列表
    getList() {
      this.$api.device
        .getActionListByControlId(this.linkageControlId)
        .then((res) => {
          if (res.code == 200) {
            for (var i = 0; i < res.data.length; i++) {
              if (
                res.data[i].switchType == 0 ||
                res.data[i].switchType == 3 ||
                res.data[i].switchType == 2
              ) {
                // 基础开关、只读开关
                if (res.data[i].executionValue == 0) {
                  res.data[i].action = "关闭";
                } else if (res.data[i].executionValue == 1) {
                  res.data[i].action = "开启";
                }
              }
              if (res.data[i].switchType == 1 || res.data[i].switchType == 4) {
                // 模拟开关
                res.data[i].action = "开度" + res.data[i].executionValue;
              } else if (res.data[i].switchType == 5) {
                // 正反转开关
                if (res.data[i].executionValue == 0) {
                  res.data[i].action = "停止";
                } else if (res.data[i].executionValue == 1) {
                  res.data[i].action = "正开";
                } else if (res.data[i].executionValue == 2) {
                  res.data[i].action = "反开";
                }
              } else if (res.data[i].switchType == 6) {
                // 展开收缩开关
                if (res.data[i].executionValue == 0) {
                  res.data[i].action = "展开停止";
                } else if (res.data[i].executionValue == 1) {
                  res.data[i].action = "收缩停止";
                } else if (res.data[i].executionValue == 2) {
                  res.data[i].action = "展开";
                } else if (res.data[i].executionValue == 3) {
                  res.data[i].action = "收缩";
                }
              } else if (res.data[i].switchType == 7) {
                // 下发开关
                res.data[i].action = "下发";
              } else if (res.data[i].switchType == 8) {
                // 自定义开关
                res.data[i].action = res.data[i].switchCmdName;
              }
            }
            this.tableData = res.data;
            this.isloading = false;
          }
        });
    },
    // 添加
    handleAdd() {
      this.title = "添加执行动作";
      this.form.id = undefined;
      this.dialogVisible = true;
    },
    // 编辑
    handleUpdate(id) {
      this.title = "编辑执行动作";
      this.form.id = id;
      this.dialogVisible = true;

      // 获取详情
      this.getDetail();
    },
    // 获取详情
    getDetail() {
      this.$api.device.getActionByDeviceId(this.form.id).then((res) => {
        if (res.code == 200) {
          var obj = {};
          obj.eid = res.data[0].eid;
          obj.linkageControlId = this.linkageControlId;
          var arr = [];
          for (var i = 0; i < res.data.length; i++) {
            if (this.controlType == "1") {
              res.data[i].linkids =
                res.data[i].linkageControlConditionId.split(",");
            } else {
              res.data[i].linkids = res.data[i].linkageControlTimeId.split(",");
            }

            for (var j = 0; j < res.data[i].linkids.length; j++) {
              res.data[i].linkids[j] = parseInt(res.data[i].linkids[j]);
            }

            res.data[i].executionValue = res.data[i].executionValue.toString();
            res.data[i].executionValueTwo =
              res.data[i].executionValueTwo.toString();

            arr.push(res.data[i]);
          }

          obj.actionList = arr;
          this.form = obj;
          this.isloading = false;

          // 获取开关属性列表
          this.getSwitchAttributes();
        }
      });
    },
    // 关闭
    handleClose() {
      this.form = {
        linkageControlId: "",
        actionList: [
          {
            controlType: 0,
            linkageControlId: "",
            type: 3,
            eid: "",
            attributeId: "",
            executionValue: "",
            executionValueTwo: "",
            sendType: "",
            needTriggerNum: "",
            needIntervalTime: "",
            weight: "",
            linkids: [],
          },
        ],
      };
      this.dialogVisible = false;
    },
    // 删除
    handleDel(id) {
      this.$confirm("是否确定删除？", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      }).then(() => {
        this.$api.device
          .delfun("pc/linkageControl/deleteLinkageControlAction", id)
          .then((res) => {
            if (res.code == 200) {
              this.getList();
              this.$toaster.ok("成功", res.msg);
            }
          });
      });
    },
    // 获取开关设备列表
    getSwitchList() {
      this.$api.device.getAllDeviceSwitchs().then((res) => {
        if (res.code == 200) {
          this.deviceArray = [];
          for (var i = 0; i < res.data.length; i++) {
            var obj = {};
            obj.name = res.data[i].name;
            obj.value = res.data[i].id;
            this.deviceArray.push(obj);
          }
        }
      });
    },
    // 设备下拉切换
    deviceChange() {
      this.form.actionList = [
        {
          controlType: 0,
          linkageControlId: "",
          type: 3,
          eid: "",
          attributeId: "",
          executionValue: "",
          executionValueTwo: "",
          sendType: "",
          needTriggerNum: "",
          needIntervalTime: "",
          weight: "",
          linkids: [],
          switchType: 0,
          customSwitchCmds: [],
        },
      ];
      // 获取开关设备属性
      this.getSwitchAttributes();
    },
    // 获取开关设备属性
    getSwitchAttributes() {
      if (this.form.eid == "") {
        return;
      }
      this.attributeArray = [];
      this.$api.device.getAttributesBySwtichId(this.form.eid).then((res) => {
        if (res.code == 200) {
          for (var i = 0; i < res.data.length; i++) {
            if (res.data[i].switchType == 2) {
              // 只读开关不能作为执行动作
              continue;
            }
            var obj = {};
            obj.id = res.data[i].id;
            obj.name = res.data[i].cname;
            obj.switchType = res.data[i].switchType;
            obj.customSwitchCmds = res.data[i].customSwitchCmds;
            this.attributeArray.push(obj);
          }
        }

        // 遍历给动作赋值开关类型
        this.conditionToSwitchType();
      });
    },
    // 属性下拉切换
    attributeChange(index) {
      // 清空属性状态
      this.form.actionList[index].executionValue = undefined;
      this.form.actionList[index].executionValueTwo = undefined;
      this.conditionToSingleSwitchType(index);
    },
    // 给动作赋值开关类型
    conditionToSingleSwitchType(index) {
      // 属性id
      var attrbuteId = this.form.actionList[index].attributeId;
      this.attributeArray.forEach((val) => {
        if (attrbuteId == val.id) {
          this.form.actionList[index].switchType = val.switchType;
          this.form.actionList[index].customSwitchCmds = val.customSwitchCmds;
          return true;
        }
      });
    },
    // 遍历给动作赋值开关类型
    conditionToSwitchType() {
      var len = this.form.actionList.length;
      for (var i = 0; i < len; i++) {
        // 属性下拉切换，处理开关类型以及开关命令
        this.conditionToSingleSwitchType(i);
      }
    },
  },
};
</script>
<style>
.box-padding {
  padding: 20px;
}

.box-bg {
  background: #fff;
}

.sc-btn31 {
  color: #20a9fd;
  position: absolute;
  top: -2px;
  right: -40px;
  cursor: pointer;
}

.newbox .el-input--suffix {
  width: 166px !important;
}

.newbox2 .el-input--suffix {
  width: 435px !important;
}

.newbox2 .el-select__tags {
  width: 335px !important;
}

.newbox2 .el-input-number--small {
  width: 435px !important;
  line-height: 30px;
}
</style>